
import React, { useState } from 'react';
import { Shop } from '../types';
import ExpandedShopFilter from './ExpandedShopFilter';
import CollapsedShopFilter from './CollapsedShopFilter';

interface ShopFilterProps {
  isCollapsed: boolean;
  setIsCollapsed: (value: boolean) => void;
  shops: Shop[];
  isLoading: boolean;
  toggleShopSelection: (id: string) => void;
  isSingleSelectionMode: boolean;
  singleSelectedShop: string;
  selectedShops: string[];
  showFilterButton?: boolean;
  filterButtonLabel?: string;
  refreshShops?: () => Promise<void>;
  title?: string;
  handleAddShop?: () => void;
}

export const ShopFilter: React.FC<ShopFilterProps> = ({
  isCollapsed,
  setIsCollapsed,
  shops,
  isLoading,
  toggleShopSelection,
  isSingleSelectionMode,
  singleSelectedShop,
  selectedShops,
  showFilterButton = true,
  filterButtonLabel = "Apply filter",
  refreshShops,
  title = "Shops",
  handleAddShop
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  // Filter shops based on search term
  const filteredShops = shops.filter(shop => 
    shop.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return isCollapsed ? (
    <CollapsedShopFilter
      setIsCollapsed={setIsCollapsed}
      shops={filteredShops}
      isLoading={isLoading}
      toggleShopSelection={toggleShopSelection}
      isSingleSelectionMode={isSingleSelectionMode}
      singleSelectedShop={singleSelectedShop}
      selectedShops={selectedShops}
      refreshShops={refreshShops}
    />
  ) : (
    <ExpandedShopFilter
      setIsCollapsed={setIsCollapsed}
      shops={shops}
      isLoading={isLoading}
      toggleShopSelection={toggleShopSelection}
      isSingleSelectionMode={isSingleSelectionMode}
      singleSelectedShop={singleSelectedShop}
      selectedShops={selectedShops}
      showFilterButton={showFilterButton}
      refreshShops={refreshShops}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      title={title}
      filterButtonLabel={filterButtonLabel}
      handleAddShop={handleAddShop}
    />
  );
};
